import { useState, useEffect } from 'react';

function useViewportChange() {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth < 768 && !isMobile) setIsMobile(true);
      else if (window.innerWidth >= 768 && isMobile) setIsMobile(false);
    };

    onResize();
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [isMobile]);

  return { isMobile };
}

export default useViewportChange;
